var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlackPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H12H21",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2198 5.82843L17.1696 10.7781M12.2198 5.82843L15.0483 3L19.998 7.94975L17.1696 10.7781L12.2198 5.82843ZM12.2198 5.82843L6.6132 11.435C6.42567 11.6225 6.32031 11.8769 6.32031 12.1421V16.6776H10.8559C11.1211 16.6776 11.3754 16.5723 11.563 16.3847L17.1696 10.7781L12.2198 5.82843Z",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlackPencil);
export default __webpack_public_path__ + "static/media/editBlackPencil.205a394401aff555324e104097c6ef77.svg";
export { ForwardRef as ReactComponent };